import {IHttpService} from "angular";
import {CurrentUserService} from "../user/CurrentUserService";
import {StrategyTemplate} from "./models/StrategyTemplate";

export class StrategiesService {

    public static id = "strategiesService";

    private strategiesRequest: Promise<Array<StrategyTemplate>>;

    /** @ngInject */
    public constructor(private $http: IHttpService, private currentUserService: CurrentUserService) {
    }

    public async strategies(): Promise<Array<StrategyTemplate>> {
        if (this.strategiesRequest == null) {
            const response = await this.$http.get<Array<StrategyTemplate>>("app/apps/optionsCookbook/strategies.json");
            const strategies = response.data!;
            const filteredStrategies = strategies.filter(s => this.canAccessStrategy(s));
            this.strategiesRequest = Promise.resolve(filteredStrategies);
        }
        return this.strategiesRequest;
    }

    private canAccessStrategy(strategy: StrategyTemplate): boolean {
        return strategy.feature == null || this.currentUserService.hasFeature(strategy.feature);
    }
}
